<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Setup Form
  </div>

  <div class="searchboxAerar p-3">
    <form nz-form [formGroup]="setupForm">
      <fieldset>
        <legend style="font-size: 18px; color: rgb(0, 0, 0)" class="text-weight">
          Correction Request Payment Setup
        </legend>
      </fieldset>

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-6">
          <nz-form-item>
            <nz-form-label>Payment Applicable?</nz-form-label>
            <nz-form-control>
              <div class="custom-control custom-switch custom-switch-sm">
                <input
                  class="custom-control-input"
                  type="checkbox"
                  id="stpCorrectionPaymentApplicable"
                  formControlName="isPaymentApplicable"
                  (change)="onPaymentChange()"
                />
                <label class="custom-control-label" for="stpCorrectionPaymentApplicable"></label>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="form-group col-md-6" *ngIf="setupForm.get('isPaymentApplicable')?.value">
          <nz-form-item>
            <nz-form-label nzRequired>Payment Amount</nz-form-label>
            <nz-form-control [nzErrorTip]="paymentAmountErrorTpl">
              <input
                nz-input
                type="text"
                placeholder="Payment Amount"
                formControlName="paymentAmount"
                onkeyup="value=value.replace(/[^0-9^\.]+/g,'')"
              />
            </nz-form-control>
            <ng-template #paymentAmountErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter payment amount!
              </ng-container>
              <ng-container *ngIf="control.hasError('pattern')">
                Please enter valid payment amount!
              </ng-container>
            </ng-template>
          </nz-form-item>
        </div>
      </div>

      <fieldset>
        <legend style="font-size: 18px; color: rgb(0, 0, 0)" class="text-weight">
          Draft Cleanup Setup
        </legend>
      </fieldset>

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-6">
          <nz-form-item>
            <nz-form-label>Delete Draft After Days</nz-form-label>
            <nz-form-control>
              <input
                nz-input
                type="text"
                placeholder="Delete Draft Application After Following Days"
                formControlName="deleteAfterDays"
                onkeyup="value=value.replace(/[^0-9^\.]+/g,'')"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="row justify-content-center media-button">
        <div class="col-xs-6 col-sm-3">
          <button
            type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!setupForm.valid"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure to save this payment setup info?"
            (nzOnConfirm)="saveSetupInfo()"
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> Save
          </button>
        </div>
      </div>
    </form>

    <form nz-form [formGroup]="cooldownForm" class="mt-4">
      <fieldset>
        <legend style="font-size: 18px; color: rgb(0, 0, 0)" class="text-weight">
          Re-apply Waiting Period
        </legend>
      </fieldset>

      <nz-alert
        style="margin: 0 12px 16px"
        nzType="info"
        nzShowIcon
        [nzMessage]="'In force today: ' + (currentCooldownDays != null ? currentCooldownDays : '—') + ' days'"
        nzDescription="Days after a Not Approved decision before the STP/SAC or the course/center can re-apply. One value for both. A change applies to everyone, also to applications already Not Approved (re-apply opens on decision date + the days in force)."
      ></nz-alert>

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-item>
            <nz-form-label nzRequired>Waiting Period (Days)</nz-form-label>
            <nz-form-control nzErrorTip="Please enter whole days between 0 and 3650!">
              <input nz-input type="text" placeholder="e.g. 90" formControlName="days"
                onkeyup="value=value.replace(/[^0-9]+/g,'')" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="form-group col-md-4">
          <nz-form-item>
            <nz-form-label>In Force From</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="startDate" nzFormat="dd-MM-yyyy" nzPlaceHolder="Today"
                style="width: 100%"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="form-group col-md-4">
          <nz-form-item>
            <nz-form-label>Remarks</nz-form-label>
            <nz-form-control>
              <input nz-input type="text" placeholder="Reason for the change" formControlName="remarks" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="row justify-content-center media-button">
        <div class="col-xs-6 col-sm-3">
          <button
            type="button"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!cooldownForm.valid || isCooldownSaving"
            nz-popconfirm
            nzPopconfirmTitle="Save the new re-apply waiting period? It applies to every STP and course/center re-apply."
            (nzOnConfirm)="saveReapplyCooldownInfo()"
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> Save
          </button>
        </div>
      </div>

      <div class="mt-3" style="margin: 0 12px">
        <nz-table #cooldownTable [nzData]="cooldownHistory" nzSize="small" nzBordered [nzPageSize]="5"
          [nzShowPagination]="cooldownHistory.length > 5">
          <thead>
            <tr>
              <th>Days</th>
              <th>In Force From</th>
              <th>Saved On</th>
              <th>Remarks</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of cooldownTable.data">
              <td>{{ row.days }}</td>
              <td>{{ row.startDate ? (row.startDate | date: 'dd-MM-yyyy') : '—' }}</td>
              <td>{{ row.createdAt ? (row.createdAt | date: 'dd-MM-yyyy hh:mm a') : '—' }}</td>
              <td>{{ row.remarks || '—' }}</td>
              <td>{{ row.isActive ? 'Yes' : 'No' }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </form>
  </div>

</div>
